import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Alert, Button, Form, Input } from 'antd';
import { kedoLogin } from './kedoApi';
import './KedoShell.css';

const KedoLoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const onFinish = async values => {
        setLoading(true);
        setError('');
        try {
            await kedoLogin(values);
            navigate(location.state?.from || '/kedo/app', { replace: true });
        } catch (e) {
            setError(
                e?.response?.data?.message || e.message || 'Ошибка входа'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="kedo-auth-wrap">
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
            />
            <div className="kedo-auth-card">
                <Link to="/kedo" className="kedo-brand">
                    <span className="kedo-brand-mark">Kedo</span>
                </Link>
                <h1>Вход</h1>
                <p className="muted">Кабинет организации КЭДО / ЭДО</p>
                {error ? (
                    <Alert
                        type="error"
                        message={error}
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                ) : null}
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Укажите email' },
                            { type: 'email', message: 'Некорректный email' }
                        ]}
                    >
                        <Input size="large" autoComplete="email" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Пароль"
                        rules={[{ required: true, message: 'Укажите пароль' }]}
                    >
                        <Input.Password
                            size="large"
                            autoComplete="current-password"
                        />
                    </Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        size="large"
                        loading={loading}
                        style={{
                            background: '#1b7a55',
                            borderColor: '#1b7a55'
                        }}
                    >
                        Войти
                    </Button>
                </Form>
                <p style={{ marginTop: 18, marginBottom: 0 }}>
                    Нет аккаунта? <Link to="/kedo/register">Регистрация</Link>
                </p>
            </div>
        </div>
    );
};

export default KedoLoginPage;
